import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;

const black = colors.ui.black[500];
const coreBlue500 = colors.ui.core[500];
const neutral400 = colors.ui.neutral[400];
const neutral700 = colors.ui.neutral[700];
const white = colors.ui.white[500];

export const containerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: 16,
};

export const pairsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: 16,
};

export const pairRowCss: CSSObject = {
  display: "grid",
  gridTemplateColumns: "1fr 50px 1fr",
  gap: 16,
  alignItems: "center",
};

export const columnCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
};

export const columnHeaderCss: CSSObject = {
  ...typographyStyles.heading5Obj,
  color: black,
  fontSize: 16,
  fontWeight: 700,
  textAlign: "center",
};

export const textAreaContainerCss: CSSObject = {
  display: "flex",
  width: "100%",
  minHeight: 113,
  padding: "16px 8px",
  border: `4px solid ${coreBlue500}`,
  borderRadius: 32,
  color: neutral700,
  backgroundColor: white,
};

export const textAreaCss: CSSObject = {
  flex: 1,
  width: "100%",
  resize: "none",
  border: `1px solid ${neutral400}`,
  borderRadius: 8,
  padding: "0.5em",
  backgroundColor: "transparent",
  ...typographyStyles.textMObj,
};

export const headersRowCss: CSSObject = {
  display: "grid",
  gridTemplateColumns: "1fr 79px 1fr",
  gap: 16,
  marginTop: 11,
};

export const arrowSvgCss: CSSObject = {
  width: "100%",
  color: coreBlue500,
};
